import {Service} from '@s-ui/domain'
/**
 * @implements Service
 */
export class EditDraftService extends Service {
  constructor({cookieRepository, httpRepository}) {
    super()
    this._cookieRepository = cookieRepository
    this._httpRepository = httpRepository
  }

  /**
   * @return {Promise<DraftEntity, Error>} returns the draft entity
   */
  async execute({categoryId, requestDraftVO, userEntity}) {
    if (userEntity) {
      return this._httpRepository.editDraft({
        categoryId,
        requestDraftVO
      })
    }

    const anonymousDraft = map({draft: requestDraftVO.toJSON()})
    return this._cookieRepository.saveAnonymousDraft({anonymousDraft})
  }
}

const map = ({draft}) => {
  const {
    bodyTypeIdWithDoors,
    carPlate,
    colourId,
    comments,
    email,
    environmentalLabel,
    fuelId,
    hidePhone,
    images,
    makeId,
    mileage,
    modelId,
    phone,
    plateRegistrationDate,
    price,
    provinceId,
    publishInVibbo,
    transmissionTypeId,
    versionId,
    year,
    zipCode
  } = draft

  return {
    body: bodyTypeIdWithDoors ?? null,
    carPlate: carPlate ?? null,
    colour: colourId ?? null,
    comments: comments ?? null,
    email: email ?? null,
    environmentalLabel: environmentalLabel ?? 'UNSPECIFIED',
    fuel: fuelId ?? null,
    hidePhone: hidePhone ?? false,
    images: images ?? [],
    km: mileage ?? null,
    make: makeId ?? null,
    model: modelId ?? null,
    phone: phone ?? null,
    plateRegistrationDate: plateRegistrationDate ?? null,
    price: price ?? null,
    province: provinceId ?? null,
    publishInMA: publishInVibbo ?? true,
    transmission: transmissionTypeId ?? null,
    version: versionId ?? null,
    year: year ?? null,
    zipCode: zipCode ?? null
  }
}
